function initializeViewBySwitcher() {
  const productGrid = document.querySelector('#product-grid');
  const desktopButtons = document.querySelectorAll('.desktop-view-by-content');
  const mobileButtons = document.querySelectorAll('.mobile-view-by-content');

  if (!productGrid) {
    console.error("Product grid element (#product-grid) not found.");
    return;
  }

  desktopButtons.forEach(button => {
    button.addEventListener('click', function() {
      desktopButtons.forEach(btn => btn.classList.remove('active'));
      this.classList.add('active');

      const viewedBy = this.getAttribute('data-viewed-by');
      productGrid.classList.remove('grid--3-col-desktop', 'grid--4-col-desktop');

      if (viewedBy === '3') {
        productGrid.classList.add('grid--3-col-desktop');
      } else if (viewedBy === '4') {
        productGrid.classList.add('grid--4-col-desktop');
      }
    });
  });


  mobileButtons.forEach(button => {
    button.addEventListener('click', function() {
      mobileButtons.forEach(btn => btn.classList.remove('active'));
      this.classList.add('active');
      
      const viewedBy = this.getAttribute('data-viewed-by');
      productGrid.classList.remove('grid--1-col-tablet-down', 'grid--2-col-tablet-down');
      
      if (viewedBy === '1') {
        productGrid.classList.add('grid--1-col-tablet-down');
      } else if (viewedBy === '2') {
        productGrid.classList.add('grid--2-col-tablet-down');
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', function() {
    initializeViewBySwitcher();
});